<ng-container *ngIf="!isLoading; else loading">
  <ng-container *ngFor="let form of feeFormItems; let i = index">
    <app-booking-fee-form [form]="form" [currencyCode]="currencyCode" [showDueUponArrival]="true" (remove)="onRemove(i)"></app-booking-fee-form>
  </ng-container>
</ng-container>

<ng-template #loading>
  <app-loading-section></app-loading-section>
</ng-template>
